module.exports = __webpack_public_path__ + "img/ok.930433f9.svg";